import { Box, Typography } from '@mui/material';
import { getDirectionFromBearing } from 'features/mapping/mapping.utils';
import { WindDirectionIcon } from './WindDirectionIcon';

type WindDirectionStatProps = {
  windDirection: number;
  windDirectionToward: number;
};

export const WindDirectionStat = (
  props: WindDirectionStatProps,
): JSX.Element => {
  const { windDirection, windDirectionToward } = props;

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
      }}
    >
      <Typography
        component="span"
        sx={{ fontWeight: 'fontWeightBold', mr: 0.5 }}
      >
        {getDirectionFromBearing(windDirection)}
      </Typography>
      <WindDirectionIcon degrees={windDirectionToward} />
    </Box>
  );
};
